import { render, staticRenderFns } from "./PsPatientListEventuals.vue?vue&type=template&id=5c43cbe8&scoped=true&"
import script from "./PsPatientListEventuals.vue?vue&type=script&lang=js&"
export * from "./PsPatientListEventuals.vue?vue&type=script&lang=js&"
import style0 from "./PsPatientListEventuals.vue?vue&type=style&index=0&id=5c43cbe8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c43cbe8",
  null
  
)

export default component.exports